'use strict';

angular.module('app').factory('HoldingAppVersion', HoldingAppVersion);

function HoldingAppVersion($q, $http, $interval, $log, $rootScope, $timeout, HoldingAppVersionValue) {
  'ngInject';

  var APP_VERSION_FILE = '/version.txt';
  var CHECK_APP_VERSION_INTERVAL = 30000;
  var GLOBAL_APP_RELOAD_PARAM = 'reloadApp';

  return {
    init: init
  };

  function checkAppVersion() {
    return getAppVersion().then(function (hash) {
      if (hash !== HoldingAppVersionValue) {
        $log.debug('need to refresh pages', hash, APP_VERSION_FILE);
      }

      $timeout(function () {
        $rootScope.globalAlerts[GLOBAL_APP_RELOAD_PARAM] = hash !== HoldingAppVersionValue;
      });
    }, function (error) {
      return $log.error(error);
    });
  }

  function getAppVersion() {
    return $http.get(APP_VERSION_FILE, {
      cache: false,
      params: {
        t: Date.now()
      }
    }).then(function (_ref) {
      var data = _ref.data;
      return $q.resolve(data);
    }, function () {
      return $q.reject('Can\'t get app version.');
    });
  }

  function init() {
    if (!$rootScope.globalAlerts) {
      $rootScope.globalAlerts = {};
    }

    $interval(checkAppVersion, CHECK_APP_VERSION_INTERVAL);
  }
}


// WEBPACK FOOTER //
// ./src/holding/holding.js